export default __webpack_public_path__ + "static/xcheck-414320c303fb2773b6f1574f7f08afe6.png";